export default "__VITE_ASSET__cf96af28__"